import { useState as e } from "react";
import { jsx as t, jsxs as n } from "react/jsx-runtime";
import { normalizeSymbolIconName as r } from "@frontends/util-utils";
//#region src/components/SymbolIcon.tsx
var i = 20, a = .75, o = .3, s = .075, c = .5, l = /[\p{L}\p{N}]/u, u = {
	display: "block",
	flexShrink: 0,
	overflow: "hidden",
	borderRadius: "50%",
	backgroundColor: "color-mix(in srgb, currentColor 8%, transparent)",
	outline: "1px solid color-mix(in srgb, currentColor 10%, transparent)",
	outlineOffset: -1
}, d = {
	display: "block",
	width: "100%",
	height: "100%",
	objectFit: "cover"
}, f = {
	display: "flex",
	alignItems: "center",
	justifyContent: "center",
	width: "100%",
	height: "100%",
	color: "color-mix(in srgb, currentColor 60%, transparent)",
	fontWeight: 600,
	lineHeight: 1,
	letterSpacing: 0,
	userSelect: "none"
};
function p(e) {
	return e?.match(l)?.[0].toUpperCase();
}
function m(e, t, n) {
	let r = `radial-gradient(circle at ${e}px ${t}px, transparent ${n}px, #000 ${n + .5}px)`;
	return {
		maskImage: r,
		WebkitMaskImage: r
	};
}
function h({ url: n, initial: r, size: i, style: a }) {
	let [o, s] = e(), l = !!n && n !== o;
	return /* @__PURE__ */ t("span", {
		style: {
			...u,
			width: i,
			height: i,
			...a
		},
		children: l ? /* @__PURE__ */ t("img", {
			src: n,
			alt: "",
			width: i,
			height: i,
			draggable: !1,
			onError: () => s(n),
			style: d
		}) : r && /* @__PURE__ */ t("span", {
			"aria-hidden": "true",
			style: {
				...f,
				fontSize: Math.round(i * c)
			},
			children: r
		})
	});
}
function g({ logoUrls: e, symbol: r, size: c = i, layout: l = "inline", className: u, style: d }) {
	let f = p(r);
	if (!e || e.length < 2) return /* @__PURE__ */ t("span", {
		className: u,
		style: {
			display: "inline-flex",
			flexShrink: 0,
			...d
		},
		children: /* @__PURE__ */ t(h, {
			url: e?.[0],
			initial: f,
			size: c
		})
	});
	let g = c * s;
	if (l === "stacked") {
		let r = Math.round(c * a), i = c - r, o = r / 2;
		return /* @__PURE__ */ n("span", {
			className: u,
			style: {
				position: "relative",
				isolation: "isolate",
				display: "inline-block",
				flexShrink: 0,
				width: c,
				height: c,
				...d
			},
			children: [/* @__PURE__ */ t(h, {
				url: e[1],
				size: r,
				style: {
					position: "absolute",
					top: 0,
					right: 0,
					...m(o - i, i + o, o + g)
				}
			}), /* @__PURE__ */ t(h, {
				url: e[0],
				initial: f,
				size: r,
				style: {
					position: "absolute",
					left: 0,
					bottom: 0
				}
			})]
		});
	}
	let _ = Math.round(c * o), v = c / 2;
	return /* @__PURE__ */ n("span", {
		dir: "ltr",
		className: u,
		style: {
			display: "inline-flex",
			alignItems: "center",
			isolation: "isolate",
			flexShrink: 0,
			width: c * 2 - _,
			height: c,
			...d
		},
		children: [/* @__PURE__ */ t(h, {
			url: e[0],
			initial: f,
			size: c
		}), /* @__PURE__ */ t(h, {
			url: e[1],
			size: c,
			style: {
				marginLeft: -_,
				...m(_ - v, v, v + g)
			}
		})]
	});
}
//#endregion
//#region src/generated/symbol-names.generated.ts
var _ = /* @__PURE__ */ "100GBP.100GBPm.A.AAL.AAPL.AAV.ADA.ADS.AF.AI.AIA.AIG.AIR.ALG.ALI.ALV.AMZN.ANK.APE.APT.ARW.ATM.AUD.AUS200.AUS200m.AVA.AXS.BA.BAC.BAR.BAS.BAT.BATS.BAYN.BCH.BMW.BN.BNB.BNP.BRL.BTC.BVSPX.BVSPXm.C.CAD.CAK.CEL.CEO.CHF.CHR.CHZ.CITIC.CKHutchison.CLP.CNE.CNH.CNOOC.COM.COP.COT.CRV.CS.CSCO.CTS.CUC.CUCUSD.CVX.CZK.Canon.ChinaMobile.Cocoa.Cocoa Beans.Coffee Arabica.Coffee Robusta.Cotton.D40EUR.D40EURm.DGE.DIS.DJI30.DJI30m.DJIUSD.DJIUSDm.DKK.DLPN.DOG.DOT.DSH.DTE.DYD.E35EUR.E35EURm.E50EUR.E50EURm.EGL.ENJ.EOS.ETC.ETH.EUR.F.F40EUR.F40EURm.FB.FDX.FET.FIL.FLW.FNKO.FTM.GAL.GBP.GE.GLEN.GMT.GOLD247.GOOGL.GRT.GS.GSK.Gasoil.H.HD.HK50.HK50m.HKBankChina.HKD.HPQ.HSBC.HUF.Henderson.Honda.IBE.IBM.ICP.IDR.ILS.IMX.INC.ING.INR.INTC.IOS.IOT.Ind&ComBank.JNJ.JPM.JPN225.JPN225m.JPY.JSE40.JSE40m.JpnTobacco.KAV.KDDI.KNC.KO.KRW.KSM.Keyence.LHA.LNK.LPT.LRC.LTC.Lenovo.MA.MAN.MAR.MAT.MBG.MC.MCD.MKR.MMM.MRK.MSFT.MTC.MXN.Makita.MitsubisUFJ.Mitsui.Mizuho.NASUSD.NASUSDm.NDAQ.NEO.NER.NESN.NET.NFLX.NGC.NGCUSD.NKE.NOK.NOVN.NVDA.NZD.Nissan.OIL247.OMG.ONE.ONT.OR.ORCL.Orange Juice.PEP.PG.PICC.PLBY.PLN.QTM.QVolatility100.QVolatility50.QVolatility75.REN.RIO.ROG.RSR.RVN.SAN.SAP.SEK.SGD.SHB.SHEL.SHK.SIE.SKL.SNX.SOL.SP500.SP500m.SPX.SPXUSD.SPXUSDm.STO.SUS.SXP.Seven&I.ShenhuaEnrg.Softbank.Sony.South Africa 40 – JSE 40.South Africa 40 – JSE 40m.Sugar Raw.Sugar White.Sumitomo.T.TET.THB.TON.TQQQ.TRX.TRY.TSLA.TWD.Tencent.Toshiba.Toyota.UAL.UK Gilt.UKO.UKOUSD.ULVR.UNH.UNI.US2000.US2000m.USD.USDT.USDX.USDXm.USO.USOUSD.V.VEC.VOD.VOW3.VZ.WFC.WKHS.WMT.WOO.XAG.XAGUSD.XAU.XAUUSD.XAUUSDs.XEM.XGR.XINUSD.XINUSDm.XKO.XLM.XMR.XOM.XPD.XPDUSD.XPT.XPTUSD.XRP.XRPUSD.XTZ.Xiaomi.YFI.ZAR.ZEC.ZEN.ZIL.ZRX".split(".");
//#endregion
//#region src/utils/normalizeSymbolName.ts
function v(e) {
	return r(e) || (e.match(/USDT/i)?.[0] ?? e);
}
//#endregion
//#region src/utils/getSymbolIconUrl.ts
function y(e, t) {
	let n = v(t);
	return `${e}/${encodeURIComponent(n)}.svg`;
}
//#endregion
//#region src/utils/getSymbolLogoUrls.ts
var b = new Set(_), x = 3;
function S(e, t, { preferPair: n = !1 } = {}) {
	let r = v(t), i = C(e, r);
	return n && i ? i : b.has(r) ? [y(e, r)] : i;
}
function C(e, t) {
	let n = t.slice(0, x), r = t.slice(x);
	if (t.length === x * 2 && b.has(n) && b.has(r)) return [y(e, n), y(e, r)];
}
//#endregion
export { _ as SYMBOL_NAMES, g as SymbolIcon, y as getSymbolIconUrl, S as getSymbolLogoUrls, v as normalizeSymbolName };
